import type { ElementType, ReactNode } from "react";

export interface NavItem {
  key: string;
  to: string;
  label?: string;
  icon?: ElementType;
  submenu?: NavItem[];
  external?: boolean;
  divider?: boolean;
  /** API permission required to view this menu item (e.g., 'vehicle_view') */
  permission?: string;
  /** Temporary escape hatch for frontend-defined permissions not yet exposed by the session API. */
  allowWithoutPermission?: boolean;
  /** Multiple permissions - user needs ANY one (OR logic) */
  permissions?: string[];
  /** Allowed user types (subcontractor field values: 0=Normal, 1=Subcontractor, 2=Funding Source, 3=Center User, 4=Ecolane) */
  allowedUserTypes?: number[];
  /** Custom action to perform on click */
  onClick?: () => void;
  /** When true, renders a version string + "Release notes" link row */
  versionInfo?: boolean;
  /** The version string to display alongside the release-notes link */
  version?: string;
  /** URL for the "Release notes" anchor */
  releaseNotesUrl?: string;
}

export interface NavMenuProps {
  title: string;
  menuId: string;
  items: NavItem[];
  isUserMenu?: boolean;
  openMenu: string | null;
  isRouteActive: boolean;
  onToggle: (menuId: string) => void;
  onClose: () => void;
}

export interface SubMenuProps {
  title: string;
  children: ReactNode;
  closeParentMenu: () => void;
}

export type NavItemsMap = Record<string, NavItem[]>;

export const MEGA_MENU_IDS = new Set(["operations", "admin", "tools", "system"]);
